import config from "@/config"
import http from "@/utils/request"

export default {
  address: {
    url: `${config.API_URL}/special`,
    name: "地址接口",
    searchNearbyPois: async function (data = {}) {
      return await http.post(`${this.url}/accets/searchNearbyPois`, data)
    }
  }
}
